 
 
 
 
 
 
define([
    'leaflet',
    './../simpleSVGIcon',
    'display/layers/defaultIconsMappingProvider'
], function(
    L,
    simpleSVGIcon,
    defaultIconsMappingProvider
) {
    'use strict';
    var ICONS = defaultIconsMappingProvider.defaultIcons;

    function isSingleColorIcon(poiClassification) {
        return poiClassification && poiClassification[0] &&
            defaultIconsMappingProvider.singleColorIcons[poiClassification[0].code] !== undefined;
    }

    return function(poiData) {
        var div,
            classificationsExist = poiData.classifications && poiData.classifications.length > 0,
            iconName = classificationsExist ? ICONS[poiData.classifications[0].code] : 'flag',
            isSingleColor = isSingleColorIcon(poiData.classifications),
            icon = simpleSVGIcon('icon-' + iconName + (isSingleColor ? '' : '-black'));

        div = L.DomUtil.create('div', 'tomtom-point-content__icon');
        div.appendChild(icon);
        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/iconContent.js